import { PathsManifest } from '@zg-rentals/paths-manifest';

const getAllPaths = () => {
  const pathsManifest = new PathsManifest('/rental-manager', 'zillow');

  return pathsManifest.getAllPaths();
};

const paths = getAllPaths();

export { paths };
